export function toArrayBuffer(input: ArrayBuffer | ArrayBufferLike | ArrayBufferView): ArrayBuffer {
  if (input instanceof ArrayBuffer) {
    return input.slice(0);
  }

  if (ArrayBuffer.isView(input)) {
    return input.buffer.slice(input.byteOffset, input.byteOffset + input.byteLength) as ArrayBuffer;
  }

  return Uint8Array.from(new Uint8Array(input)).buffer;
}

export function toUint8Array(
  input: Uint8Array | Uint8ClampedArray | ArrayBuffer | ArrayBufferLike,
): Uint8Array<ArrayBuffer> {
  if (input instanceof Uint8Array && input.buffer instanceof ArrayBuffer && input.byteOffset === 0) {
    return input as Uint8Array<ArrayBuffer>;
  }

  return new Uint8Array(toArrayBuffer(input)) as Uint8Array<ArrayBuffer>;
}

export function toUint8ClampedArray(
  input: Uint8ClampedArray | Uint8Array | ArrayBuffer | ArrayBufferLike,
): Uint8ClampedArray<ArrayBuffer> {
  return new Uint8ClampedArray(toArrayBuffer(input)) as Uint8ClampedArray<ArrayBuffer>;
}
